import { GAME_ID, REDUX_ACTIONS, ITEMS_PER_ROUND } from '../../data/constants';

const initState = {
  // Curriculum Pointers
  levelIndex: 0,
  questionIndex: 0,
  stanzaIndex: 0,
  questionIdsInRound: [],
  possibleIdsInRound: [],
  levelMap: [],
  clozeMap: [],
  isCloze: false,
  progressAmount: 0,
  selectedResponse: undefined,

  galleryBoss: '',
  currentBoss: '',

  category: 0,

  possibleCorrectItems: 0,
  incorrectItemCount: 0,
  correctItemCount: 0,
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelIndex: payload,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...state,
        questionIdsInRound: [],
        possibleIdsInRound: [],
        questionIndex: 1,
        stanzaIndex: 0,
        progressAmount: 0,
        possibleCorrectItems: 0,
        incorrectItemCount: 0,
        correctItemCount: 0,
        isCloze: false,
        selectedResponse: undefined,
        category: 0,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        stanzaIndex: state.stanzaIndex + 1,
      };

    case REDUX_ACTIONS.INCREMENT_QUESTION_INDEX:
      return {
        ...state,
        questionIndex: state.questionIndex + 1,
      };

    case REDUX_ACTIONS.SET_LEVEL_MAP:
    {
      return {
        ...state,
        levelMap: payload,
      };
    }

    case REDUX_ACTIONS.SET_GALLERY_BOSS:
    {
      return {
        ...state,
        galleryBoss: payload,
      };
    }

    case REDUX_ACTIONS.SET_BOSS:
    {
      return {
        ...state,
        currentBoss: payload,
      };
    }

    case REDUX_ACTIONS.SET_CLOZE_MAP:
    {
      return {
        ...state,
        clozeMap: payload,
      };
    }

    case REDUX_ACTIONS.SET_CLOZE_STATUS:
      return {
        ...state,
        isCloze: payload,
      };

    case REDUX_ACTIONS.SET_CATEGORY:
      return {
        ...state,
        questionIdsInRound: payload.options,
        category: payload.category,
      };

    case REDUX_ACTIONS.SET_POSSIBLE_OPTIONS:
      return {
        ...state,
        possibleIdsInRound: payload,
      };

    case REDUX_ACTIONS.ADD_MAX_CORRECT_ITEMS:
      return {
        ...state,
        possibleCorrectItems: state.possibleCorrectItems + payload,
      };

    case REDUX_ACTIONS.ADD_INCORRECT_ITEMS:
      return {
        ...state,
        incorrectItemCount: state.incorrectItemCount + payload,
      };

    case REDUX_ACTIONS.ADD_CORRECT_ITEMS:
      return {
        ...state,
        correctItemCount: state.correctItemCount + payload,
      };

    case REDUX_ACTIONS.QUICK_ROUND:
      return {
        ...state,
        possibleCorrectItems: ITEMS_PER_ROUND,
        correctItemCount: payload.pass ? ITEMS_PER_ROUND : 0,
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
